module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_9006.7f02441b.png";